<template>
  <div
    class="opple-config-navBar"
  >
    <div
      class="opple-config-navBar_item"
      :class="{active: currentTab === 0}"
      @click="() => onItemClick(0)"
    >
      {{ $t('ifttt.associatedConditioning') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'OppleConfigNavBar',
  components: {

  },
  props: {

  },
  data() {
    return {
      currentTab: 0
    };
  },

  computed: {

  },

  watch: {
    item(value) {
      this.setCom();
    }
  },

  mounted() {

  },

  methods: {
    onItemClick(tab) {
      this.currentTab = tab;
    }
  },
};
</script>

<style lang="scss">
.opple-config-navBar {
  width: 283px;
  min-height: 228px;
  border-right: 2px solid #E0E5EC;

  &_item {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    color: #111;
    text-indent: 80px;
    cursor: pointer;

    &.active {
      color: #0246AB;
      background: #E1EAF7;
    }
  }
}

</style>